import React from 'react';
import { Columns3, Lock, Plus } from 'lucide-react';
import { Tooltip } from '../ui/Tooltip';
export type MarketChip = {
  code: string;
  flag: string;
  score?: number;
  locked?: boolean;
};
const lockedTooltip = 'No assessment yet — create a dossier for this market to compare';
function dotColour(score: number) {
  if (score >= 70) return 'bg-forest-green';
  if (score >= 40) return 'bg-amber-500';
  return 'bg-red-600';
}
interface MarketChipRowProps {
  caption: string;
  chips: MarketChip[];
  selected: string;
  onSelect: (code: string) => void;
  onLocked: () => void;
  onAdd: () => void;
  onCompare?: () => void;
}
export function MarketChipRow({
  caption,
  chips,
  selected,
  onSelect,
  onLocked,
  onAdd,
  onCompare
}: MarketChipRowProps) {
  return <div className="mt-6" data-id="element-977" data-mp="jl5cq3ob0e9z">
      <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.16em] text-[#8b968d]" data-id="element-978" data-mp="1h2dho7y8w0dc">{caption}</p>
      <div className="mt-2 flex flex-wrap items-center gap-2" data-id="element-979" data-mp="1cbdjz0haxe9s">
        {chips.map(chip => {
        if (chip.locked) {
          return <Tooltip key={chip.code} content={lockedTooltip} data-id="element-980" data-mp="3ef5nd4nqg96z">
                <button type="button" onClick={onLocked} className="inline-flex items-center gap-1.5 rounded-full border border-dashed border-[#c3ccc4] bg-transparent px-3 py-1.5 text-sm font-medium text-[#8b968d] transition hover:bg-[#f4f6f3]" data-id="element-981" data-mp="3jcfagdnng8rn">
                  <span aria-hidden="true" data-id="element-982" data-mp="2vmb8eaq40h2r">{chip.flag}</span>
                  {chip.code}
                  <Lock className="h-3 w-3" data-id="element-983" data-mp="30ns8w54om1it" />
                </button>
              </Tooltip>;
        }
        const isSelected = chip.code === selected;
        return <button key={chip.code} type="button" onClick={() => onSelect(chip.code)} aria-pressed={isSelected} className={`inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-sm transition ${isSelected ? 'border-forest-green bg-forest-green/10 text-evergreen' : 'border-[#dce3da] bg-transparent text-[#617366] hover:bg-[#f7faf5]'}`} data-id="element-984" data-mp="2qpul1iqqi6qq">
              <span aria-hidden="true" data-id="element-985" data-mp="1ouq57gnbhqau">{chip.flag}</span>
              <span className="font-medium" data-id="element-986" data-mp="1julpvty5b1m7">{chip.code}</span>
              {chip.score !== undefined && <>
                  <span className={`h-2 w-2 rounded-full ${dotColour(chip.score)}`} aria-hidden="true" data-id="element-987" data-mp="2gl4f71s7mih8" />
                  <span className="font-mono text-xs font-semibold" data-id="element-988" data-mp="2ckc3m1vv81hs">{chip.score}</span>
                </>}
            </button>;
      })}
        <button type="button" onClick={onAdd} className="inline-flex items-center gap-1.5 rounded-full border border-dashed border-[#c3ccc4] bg-transparent px-3 py-1.5 text-sm font-semibold text-[#617366] transition hover:bg-[#f4f6f3]" data-id="element-989" data-mp="22thij0ucv7xx">
          <Plus className="h-3.5 w-3.5" data-id="element-990" data-mp="2vg28bwv6nbzd" />
          Add
        </button>
        {onCompare && <button type="button" onClick={onCompare} className="ml-1 inline-flex items-center gap-2 rounded-lg border border-[#d6dfd3] bg-white px-3 py-1.5 text-sm font-semibold text-evergreen transition hover:bg-[#f7faf5] focus:outline-none focus-visible:ring-2 focus-visible:ring-forest-green" data-id="element-991" data-mp="32ve7jtz39tgo">
            <Columns3 className="h-4 w-4" data-id="element-992" data-mp="3lsnu3jzpnn25" />
            Compare
          </button>}
      </div>
    </div>;
}